import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-discussions',
  templateUrl: './discussions.component.html',
  styleUrls: ['./discussions.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DiscussionsComponent implements OnInit {
  sectionSubjectId: number = null;
  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(params => {
      if (!params.get('sectionSubjectId'))
       return;
      this.sectionSubjectId = +params.get('sectionSubjectId');
    });
  }
 
}
